import {
  mapFromArrangement,
  mapFromScheduleOrder,
  type PrintSortIn,
} from "./PrintSortIn.ts";
import type {
  ScheduleViewArrangement,
  ScheduleViewGroupByArrangement,
} from "@/pages/human-resources/time-management/model/ScheduleViewArrangement.ts";
import type { ScheduleEmployeesOrder } from "@/pages/human-resources/time-management/model/ScheduleEmployeesOrder.ts";

export interface PrintArrangementIn {
  sortSequence: PrintSortIn[];
  grouped: boolean;
}

export function mapFromArrangementAndOrder(
  viewArrangement: ScheduleViewArrangement,
  schedulesOrder: ScheduleEmployeesOrder,
): PrintArrangementIn {
  switch (viewArrangement) {
    case "position":
      throw new Error("Cannot print this view arrangement");
    case "employee":
      return flatArrangement(schedulesOrder);
    default:
      return groupedArrangement(viewArrangement, schedulesOrder);
  }
}

function flatArrangement(
  schedulesOrder: ScheduleEmployeesOrder,
): PrintArrangementIn {
  const sortSequence = [mapFromScheduleOrder(schedulesOrder)];
  if (schedulesOrder.order !== "name") {
    sortSequence.push({ sortType: "EMPLOYEE_NAME", reversed: false });
  }
  return {
    sortSequence,
    grouped: false,
  };
}

function groupedArrangement(
  viewArrangement: ScheduleViewGroupByArrangement,
  schedulesOrder: ScheduleEmployeesOrder,
): PrintArrangementIn {
  const secondOrder = mapFromScheduleOrder(schedulesOrder);
  const sortSequence = [mapFromArrangement(viewArrangement), secondOrder];
  if (secondOrder.sortType !== "EMPLOYEE_NAME") {
    sortSequence.push({ sortType: "EMPLOYEE_NAME", reversed: false });
  }
  return {
    sortSequence,
    grouped: true,
  };
}
